import React, { useState } from "react";
import useApi, { doFetch } from "storybook-dashboard/utils/fetching";
import Im from "immutable";

import { CompanyPermission } from "../permissions";
import TipsSpinner from "../../utils/spinners/tipsSpinner";

// Add an existing indicator to the company
const addExistingIndicator = (e, companyId, indicator, triggerIndicators) => {
  e.preventDefault();
  doFetch(`/api/company/${companyId}/indicator/?fromExisting=${indicator.get("uid")}`, "POST").then(() => {
    triggerIndicators();
  });
};

// Render table headers for indicator list
function Headers() {
  return (
    <div className="row">
      <div className="col-sm-7">
        <b>{"Name"}</b>
      </div>
      <div className="col-sm-4">
        <b>{"Category"}</b>
      </div>
      <div className="col-sm-1" />
    </div>
  );
}

// Render individual indicator row
function AddIndicatorRow({ indicator, companyId, index, triggerIndicators }) {
  return (
    <div className="row m-0 p-0" style={{ backgroundColor: (index + 1) % 2 ? "#ddd" : "" }}>
      <div className="col-sm-7">{indicator.getIn(["resultBaseMetric", "name"]) || indicator.get("name")}</div>
      <div className="col-sm-4">{indicator.getIn(["resultBaseMetric", "category"])}</div>
      <div className="col-sm-1">
        <button
          className="btn btn-sm btn-primary pt-0 pb-0 mt-1 mb-1"
          onClick={(e) => addExistingIndicator(e, companyId, indicator, triggerIndicators)}
        >
          Add
        </button>
      </div>
    </div>
  );
}

function CompanyAvailableIndicators({ companyId, toggleShowHandler }) {
  // Fetch company data
  const { data: company } = useApi("/api/company/{companyId}/", { companyId });

  // Fetch company indicators (current indicators)
  const { data: companyIndicators, trigger: triggerIndicators } = useApi("/api/company/{companyId}/indicator/", {
    companyId,
  });
  const companyIndicatorsById = companyIndicators?.reduce((acc, item) => acc.set(item.get("uid"), item), Im.Map());

  // Fetch all available indicators
  const { data: companyAvailableIndicators } = useApi("/api/company/{companyId}/indicator/?allAvailable=true", {
    companyId,
  });

  if (!company || !companyAvailableIndicators || !companyIndicators) {
    return <TipsSpinner message="Loading Indicator List. It might take a moment" />;
  }

  let unusedAvailableIndicators = companyAvailableIndicators
    .toList()
    .filter((i) => !companyIndicatorsById.get(i.get("uid")));

  console.log("CompanyAvailableIndicators", unusedAvailableIndicators?.toJS());

  if (!unusedAvailableIndicators?.size) {
    return (
      <div>
        <p>There are no indicators from sub-projects that are not already in use.</p>
        <button className="btn btn-sm btn-secondart" onClick={toggleShowHandler}>
          Close
        </button>
      </div>
    );
  }

  let listComponents = unusedAvailableIndicators.map((indicator, i) => (
    <AddIndicatorRow
      key={i}
      index={i}
      indicator={indicator}
      companyId={companyId}
      triggerIndicators={triggerIndicators}
    />
  ));

  return (
    <CompanyPermission companyId={companyId} requiresAdmin={true}>
      <Headers />
      <hr />
      {listComponents}
      <hr />
      <button className="btn btn-sm btn-secondart" onClick={toggleShowHandler}>
        Close
      </button>
    </CompanyPermission>
  );
}

export default CompanyAvailableIndicators;
